import NotFound from './NotFound.js';
export default NotFound;